/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deviceTypeEnumSchema = z.enum(["kiosk", "planshet-kiosk"]).describe("* `kiosk` - Киоск\n* `planshet-kiosk` - Планшет-киоск");
